import React, { useEffect, useState } from 'react';
import { ExternalLinkIcon, CopyIcon, CheckIcon } from 'lucide-react';

interface VideoPreviewProps {
  videoId: string | null;
}

const VideoPreview: React.FC<VideoPreviewProps> = ({ videoId }) => {
  const [copied, setCopied] = useState(false);
  
  useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => setCopied(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [copied]);

  if (!videoId) return null;
  
  const handleCopyId = () => {
    navigator.clipboard.writeText(videoId);
    setCopied(true);
  };

  return (
    <div className="mt-4 bg-gray-900 rounded-lg shadow-xl overflow-hidden border border-gray-800 transition-all duration-300 ease-in-out">
      <div className="aspect-w-16 aspect-h-9 relative">
        <iframe
          src={`https://www.youtube.com/embed/${videoId}`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          className="w-full h-full"
        ></iframe>
      </div>
      
      <div className="p-4 bg-gray-800/50 flex flex-col sm:flex-row sm:items-center justify-between">
        <div className="flex items-center">
          <span className="text-sm font-medium text-gray-300 mr-2">Video ID:</span>
          <code className="bg-gray-800 px-2 py-1 rounded text-sm text-gray-300">{videoId}</code>
          <button 
            onClick={handleCopyId} 
            className="ml-2 p-1 rounded-full hover:bg-gray-700 transition-colors"
            title="Copy Video ID"
          >
            {copied ? (
              <CheckIcon size={16} className="text-green-400" />
            ) : (
              <CopyIcon size={16} className="text-gray-400" />
            )}
          </button>
        </div>
        
        <a 
          href={`https://www.youtube.com/watch?v=${videoId}`} 
          target="_blank" 
          rel="noopener noreferrer"
          className="mt-2 sm:mt-0 inline-flex items-center text-sm text-blue-400 hover:text-blue-300 transition-colors"
        >
          Open on YouTube
          <ExternalLinkIcon size={16} className="ml-1" />
        </a>
      </div>
    </div>
  );
};

export default VideoPreview;